/**
 * Faixa de marcas na home (25/09/2026).
 *
 * ── O QUE ELA FAZ ───────────────────────────────────────────────────────────────────────────────
 *
 * Prova social: quem chega pela divulgação de um parceiro reconhece a marca e entende que não está
 * num site solto. Em página de pré-venda isso importa mais que em produto já conhecido, porque a
 * pessoa está pagando por algo que ainda não pode testar.
 *
 * ── DETALHES QUE PARECEM ESTÉTICA E NÃO SÃO ─────────────────────────────────────────────────────
 *
 * 1. **Os PNGs foram recortados.** Vinham com moldura transparente enorme — o do HT Capital era um
 *    quadrado de 1080px onde a marca ocupava 76px de altura (7%). Sem recortar, ele apareceria
 *    minúsculo ao lado dos outros por mais que se aumentasse a altura da caixa.
 * 2. **`altura` por logo, não uma altura só.** O Wolf é quase quadrado; os outros são tiras
 *    horizontais. Com a mesma altura, o quadrado parece menor do que é — o olho compara área, não
 *    altura. Por isso ele vem com um valor maior.
 * 3. **Cinza que acende no hover.** Logos coloridos e em brilho total brigariam com o preço, que é
 *    o que a página existe para vender.
 */

type Marca = { nome: string; arquivo: string; altura: number };

/**
 * A ordem é a da tela. HT Capital vem primeiro por ser a casa — decisão do dono em 25/09, depois
 * de ver a faixa com e sem ela.
 */
const MARCAS: Marca[] = [
  { nome: "HT Capital", arquivo: "/img/parceiros/ht-capital.png", altura: 44 },
  // Wolf é quase quadrado: precisa de mais altura para ter peso visual parecido com as tiras.
  { nome: "Wolf Trading Desk", arquivo: "/img/parceiros/wolf.png", altura: 66 },
  { nome: "Nomos", arquivo: "/img/parceiros/nomos.png", altura: 44 },
  { nome: "Instituto Brasileiro de Trade", arquivo: "/img/parceiros/ibt.png", altura: 44 },
];

export function FaixaParceiros() {
  return (
    <div className="hts-marcas">
      {MARCAS.map((m) => (
        <img
          key={m.nome}
          src={m.arquivo}
          /* O alt é o nome da marca: para quem usa leitor de tela, uma faixa de imagens sem texto
             é um buraco silencioso no meio da página. */
          alt={m.nome}
          style={{ height: m.altura }}
          loading="lazy"
          decoding="async"
        />
      ))}
    </div>
  );
}
